import React from 'react';

const RssFeedPage = (props) => (
	<div className="container main">
		<h2>RSS Feed</h2>
		<div className="row">
			<div className="col-sm-12">
				<p>Souhaitez-vous recevoir des notifications concernant les derniers rappels publiés sur le Portail mondial de l’OCDE sur les rappels de produits ?</p>
				<p>
					<a className={'rss-feed-link'} href={props.config.api + '/rss.xqy'}>Abonnez-vous à notre flux RSS.</a>
				</p>
				<p>Vous pouvez vous inscrire à notre flux de différentes manières :</p>
				<ul className={'rss-feed-options'}>
					<li>En copiant l’URL du flux RSS dans votre lecteur de nouvelles.</li>
					<li>En copiant l’URL du fil RSS dans votre navigateur.</li>
				</ul>
			</div>
		</div>
	</div>
);

export default RssFeedPage;



// WEBPACK FOOTER //
// ./src/views/static/fr/rss-feed.js